import React from 'react';
import { create } from 'zustand';
import { Route, Routes } from 'react-router';
import { Trafikkstasjon } from '../../utils/api';
import { VelgSkiltstorrelse } from './VelgSkiltstorrelse';
import { SendBestilling } from './SendBestilling';
import { VelgHentested } from './VelgHentested';
import { BestillingBekreftelse } from './BestillingBekreftelse';
import { VisSkiltstorrelse } from './VisSkiltstorrelse';
import Varsling from './Varsling';

type SkiltbestillingState = {
    bestillingDato: string;
    rettighetId: string;
    kjennemerkefarge: string;
    tegnkombinasjon: string;
    trafikkstasjon?: Trafikkstasjon;
    kjennemerkestorrelser: { foran: string; bak: string };
    kjennemerketype: string;
    varselmetode: string;
    varselKontaktinfo: string;
    kjennemerke: string;
    setBestillingDato: (dato: string) => void;
    setRettighetId: (rettighetId: string) => void;
    setKjennemerkefarge: (kjennemerkefarge: string) => void;
    setTegnkombinasjon: (tegnkombinasjon: string) => void;
    setTrafikkstasjon: (trafikkstasjon: Trafikkstasjon | undefined) => void;
    setKjennemerkestorrelser: (kjennemerkestorrelser: {
        foran: string;
        bak: string;
    }) => void;
    setKjennemerketype: (kjennemerketype: string) => void;
    setVarselmetode: (varselmetode: string) => void;
    setVarselKontaktinfo: (varselKontaktinfo: string) => void;
    setKjennemerke: (kjennemerke: string) => void;
};

export const useSkiltbestillingState = create<SkiltbestillingState>((set) => ({
    bestillingDato: '',
    rettighetId: '',
    kjennemerkefarge: '',
    tegnkombinasjon: '',
    trafikkstasjon: undefined,
    kjennemerkestorrelser: { foran: '', bak: '' },
    kjennemerketype: '',
    varselmetode: '',
    varselKontaktinfo: '',
    kjennemerke: '',
    setBestillingDato: (bestillingDato) => set(() => ({ bestillingDato })),
    setRettighetId: (rettighetId) => set(() => ({ rettighetId })),
    setKjennemerkefarge: (kjennemerkefarge) =>
        set(() => ({ kjennemerkefarge })),
    setTegnkombinasjon: (tegnkombinasjon) => set(() => ({ tegnkombinasjon })),
    setTrafikkstasjon: (trafikkstasjon) => set(() => ({ trafikkstasjon })),
    setKjennemerkestorrelser: (kjennemerkestorrelser) =>
        set(() => ({ kjennemerkestorrelser })),
    setKjennemerketype: (kjennemerketype) => set(() => ({ kjennemerketype })),
    setVarselmetode: (varselmetode) => set(() => ({ varselmetode })),
    setVarselKontaktinfo: (varselKontaktinfo) =>
        set(() => ({ varselKontaktinfo })),
    setKjennemerke: (kjennemerke) => set(() => ({ kjennemerke })),
}));

export const skiltbestillingsteg = [
    { value: 1, text: 'personlig-kjennemerke.bestill.steg.kjoretoy' },
    { value: 2, text: 'personlig-kjennemerke.bestill.steg.skilttype' },
    { value: 3, text: 'personlig-kjennemerke.bestill.steg.hentested' },
    { value: 4, text: 'personlig-kjennemerke.bestill.steg.varsling' },
    { value: 5, text: 'personlig-kjennemerke.bestill.steg.bekreft' },
];

export const Skiltbestilling: React.FC = () => {
    return (
        <Routes>
            <Route path="*" element={<VelgSkiltstorrelse />} />
            <Route path="storrelse" element={<VisSkiltstorrelse />} />
            <Route path="hentested" element={<VelgHentested />} />
            <Route path="varsling" element={<Varsling />} />
            <Route path="send" element={<SendBestilling />} />
            <Route path="bekreftelse" element={<BestillingBekreftelse />} />
        </Routes>
    );
};
